export default {
	section_banner: {
		title: {
			one: 'Register',
		},
		main_title: {
			one: 'As A JPWorldPay',
			two: 'Merchant',
		},
		paragraph: {
			one: 'Payments made by customers are settled by the registered merchant, ensuring a smooth, transparent, and direct transaction process with complete financial control.',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},

	question_sec: {
		label: 'Even If There Are Many Affiliated Stores',
		title: {
			one: 'All Settlements',
			two: 'Are Made At',
			three: 'Once',
		},
		paragraph: {
			one: 'It is calculated meticulously, without missing a single item. JPWorldPay ensures that every transaction is accounted for with precision, providing transparent and reliable financial records.',
			two: 'This attention to detail helps businesses maintain accuracy in reporting, avoid discrepancies, and build trust with their partners and customers.',
		},
		cta_buttons: {
			one: 'Make Payment',
		},
	},

	business_asset_btm: {
		label: 'Easy & Smooth Process',
		title: {
			one: 'Pay Any',
			two: 'Time',
			three: 'Any',
			four: 'Way',
			five: 'You Want',
		},
		paragraph: {
			one: 'You can pay with cryptocurrency and pay with your desired currency pair. JPWorldPay offers flexible payment options, allowing users to choose the currency that suits them best. Whether it is for local or international transactions, this versatility makes payments seamless and convenient.',
		},
		cta_buttons: {
			one: 'Get Started',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
